import { DashboardMenuItemWithPath } from "./types";
import {
  baseComedianMenuItemsWithSubitems,
  baseComedianMenuItemsWithoutSubitems,
  baseComedianTrailingMenuItems,
} from "./useDashboardMenuItems";

function collectPaths(items: DashboardMenuItemWithPath[]): string[] {
  return items.flatMap((item) => [
    item.path,
    ...(item.subitems ? collectPaths(item.subitems) : []),
  ]);
}

// Routes that exist as page.tsx files but are not sidebar menu items
const SUPPLEMENTARY_PATHS = [
  "/dashboard",
  "/dashboard/content/new",
  "/dashboard/content/bulk-upload",
  "/dashboard/content/podcasts",
  "/dashboard/content/collections",
  "/dashboard/content/subscriptions",
  "/dashboard/checkout",
  "/dashboard/messages/automations/checkout",
];

// Paths from feature-gated menu items added in the hook body rather than the base
// arrays, included here unconditionally so comedian-switching always works.
const GATED_PATHS = [
  "/dashboard/moderation",
  "/dashboard/audiences/all-contacts",
  "/dashboard/audiences/all-contacts/list",
  "/dashboard/audiences/all-contacts/map",
  "/dashboard/audiences/lists",
  "/dashboard/plan-usage",
  "/dashboard/billing",
];

export const KNOWN_DASHBOARD_PATHS = new Set(
  [
    ...collectPaths(baseComedianMenuItemsWithSubitems),
    ...collectPaths(baseComedianMenuItemsWithoutSubitems),
    ...collectPaths(baseComedianTrailingMenuItems),
    ...GATED_PATHS,
    ...SUPPLEMENTARY_PATHS,
  ].map((p) => p.replace(/^\//, ""))
);
